import { OverviewJobSectionEmptyState_organization$key } from '#app/__generated__/relay/OverviewJobSectionEmptyState_organization.graphql.js';
import { Button } from '#app/components/Buttons/Button.js';
import { Text } from '#app/components/Primitives/Text.js';
import { useNewJob } from '#app/features/job/hooks/useNewJob.js';
import EmptyStateImage from './assets/jobs-empty.webp';
import {
  EmptyStateCard,
  Image,
  MessageContainer,
} from './EmptyState.styles.js';
import { graphql, useFragment } from '@contra/relay';

type OverviewJobSectionEmptyStateProps = {
  readonly organizationRef: OverviewJobSectionEmptyState_organization$key;
};

export const OverviewJobSectionEmptyState = ({
  organizationRef,
}: OverviewJobSectionEmptyStateProps) => {
  const organization =
    useFragment<OverviewJobSectionEmptyState_organization$key>(
      graphql`
        fragment OverviewJobSectionEmptyState_organization on Organization {
          name
          visitorIsMember
        }
      `,
      organizationRef,
    );
  const { onClick } = useNewJob({
    analyticsEvent: [
      'button',
      {
        action: 'tapped',
        button_name: 'company_profile_owner_empty_state_post_job',
      },
    ],
  });

  const isMember = organization.visitorIsMember;

  return (
    <EmptyStateCard>
      <Image
        alt="Image of a project listing with a 3D glass shopping bag behind it"
        src={EmptyStateImage}
      />
      <MessageContainer>
        <Text
          as="h3"
          color="gray80"
          textStyle="subtitleRegular"
        >
          {isMember ? (
            <>Your team hasn’t posted any jobs, yet!</>
          ) : (
            <>There are no active jobs</>
          )}
        </Text>
        <Text
          color="gray70"
          textStyle="bodySmall"
        >
          {isMember ? (
            <>
              Your teams posted jobs will appear here. Start posting jobs and
              get matched with top contractors.
            </>
          ) : (
            <>
              As {organization.name ?? 'Organization'} posts jobs, they'll be
              listed on this page.
            </>
          )}
        </Text>
        {isMember ? (
          <Button
            onClick={onClick}
            removeMinWidth
            size="small"
            variant="V2Primary"
          >
            Post a job
          </Button>
        ) : null}
      </MessageContainer>
    </EmptyStateCard>
  );
};
